// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PayCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PayCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var PayCircleOutlined = function PayCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleOutlinedSvg
  }));
};

PayCircleOutlined.displayName = 'PayCircleOutlined';
export default React.forwardRef(PayCircleOutlined);